module.exports = __webpack_public_path__ + "img/honeywell.bd9dc50d.png";